module.exports = __webpack_public_path__ + "static/media/concha.c5b0bc50.svg";